"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var contract_wrappers_1 = require("@0x/contract-wrappers");
var json_schemas_1 = require("@0x/json-schemas");
var order_utils_1 = require("@0x/order-utils");
var utils_1 = require("@0x/utils");
var web3_wrapper_1 = require("@0x/web3-wrapper");
var _ = require("lodash");
var constants_1 = require("./constants");
var basic_order_provider_1 = require("./order_providers/basic_order_provider");
var standard_relayer_api_order_provider_1 = require("./order_providers/standard_relayer_api_order_provider");
var types_1 = require("./types");
var assert_1 = require("./utils/assert");
var buy_quote_calculator_1 = require("./utils/buy_quote_calculator");
var calculate_liquidity_1 = require("./utils/calculate_liquidity");
var number_percentage_to_ethertoken_amount_percentage_1 = require("./utils/number_percentage_to_ethertoken_amount_percentage");
var order_provider_response_processor_1 = require("./utils/order_provider_response_processor");
var AssetBuyer = /** @class */ (function () {
    /**
     * Instantiates a new AssetBuyer instance
     * @param   supportedProvider   The Provider instance you would like to use for interacting with the Ethereum network.
     * @param   orderProvider       An object that conforms to OrderProvider, see type for definition.
     * @param   options             Initialization options for the AssetBuyer. See type definition for details.
     *
     * @return  An instance of AssetBuyer
     */
    function AssetBuyer(supportedProvider, orderProvider, options) {
        if (options === void 0) { options = {}; }
        // cache of orders along with the time last updated keyed by assetData
        this._ordersEntryMap = {};
        var _a = _.merge({}, constants_1.constants.DEFAULT_ASSET_BUYER_OPTS, options), chainId = _a.chainId, orderRefreshIntervalMs = _a.orderRefreshIntervalMs, expiryBufferSeconds = _a.expiryBufferSeconds;
        var provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
        assert_1.assert.isValidOrderProvider('orderProvider', orderProvider);
        assert_1.assert.isNumber('chainId', chainId);
        assert_1.assert.isNumber('orderRefreshIntervalMs', orderRefreshIntervalMs);
        assert_1.assert.isNumber('expiryBufferSeconds', expiryBufferSeconds);
        this.provider = provider;
        this.orderProvider = orderProvider;
        this.chainId = chainId;
        this.orderRefreshIntervalMs = orderRefreshIntervalMs;
        this.expiryBufferSeconds = expiryBufferSeconds;
        this._contractWrappers = new contract_wrappers_1.ContractWrappers(this.provider, {
            chainId: chainId,
        });
    }
    /**
     * Instantiates a new AssetBuyer instance given existing liquidity in the form of orders and feeOrders.
     * @param   supportedProvider       The Provider instance you would like to use for interacting with the Ethereum network.
     * @param   orders                  A non-empty array of objects that conform to SignedOrder. All orders must have the same makerAssetData and takerAssetData (WETH).
     * @param   feeOrders               A array of objects that conform to SignedOrder. All orders must have the same makerAssetData (ZRX) and takerAssetData (WETH). Defaults to an empty array.
     * @param   options                 Initialization options for the AssetBuyer. See type definition for details.
     *
     * @return  An instance of AssetBuyer
     */
    AssetBuyer.getAssetBuyerForProvidedOrders = function (supportedProvider, orders, options) {
        if (options === void 0) { options = {}; }
        assert_1.assert.doesConformToSchema('orders', orders, json_schemas_1.schemas.signedOrdersSchema);
        assert_1.assert.assert(orders.length !== 0, "Expected orders to contain at least one order");
        var orderProvider = new basic_order_provider_1.BasicOrderProvider(orders);
        var assetBuyer = new AssetBuyer(supportedProvider, orderProvider, options);
        return assetBuyer;
    };
    /**
     * Instantiates a new AssetBuyer instance given a [Standard Relayer API](https://github.com/0xProject/standard-relayer-api) endpoint
     * @param   supportedProvider       The Provider instance you would like to use for interacting with the Ethereum network.
     * @param   sraApiUrl               The standard relayer API base HTTP url you would like to source orders from.
     * @param   options                 Initialization options for the AssetBuyer. See type definition for details.
     *
     * @return  An instance of AssetBuyer
     */
    AssetBuyer.getAssetBuyerForStandardRelayerAPIUrl = function (supportedProvider, sraApiUrl, options) {
        if (options === void 0) { options = {}; }
        var provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
        assert_1.assert.isWebUri('sraApiUrl', sraApiUrl);
        // HACK: asset-buy will be deleted, but do not pass in chainId to allow everything to compile.
        var orderProvider = new standard_relayer_api_order_provider_1.StandardRelayerAPIOrderProvider(sraApiUrl);
        var assetBuyer = new AssetBuyer(provider, orderProvider, options);
        return assetBuyer;
    };
    /**
     * Get a `BuyQuote` containing all information relevant to fulfilling a buy given a desired assetData.
     * You can then pass the `BuyQuote` to `executeBuyQuoteAsync` to execute the buy.
     * @param   assetData           The assetData of the desired asset to buy (for more info: https://github.com/0xProject/0x-protocol-specification/blob/master/v2/v2-specification.md).
     * @param   assetBuyAmount      The amount of asset to buy.
     * @param   options             Options for the request. See type definition for more information.
     *
     * @return  An object that conforms to BuyQuote that satisfies the request. See type definition for more information.
     */
    AssetBuyer.prototype.getBuyQuoteAsync = function (assetData, assetBuyAmount, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, feePercentage, shouldForceOrderRefresh, slippagePercentage, zrxTokenAssetData, isMakerAssetZrxToken, _b, ordersAndFillableAmounts, feeOrdersAndFillableAmounts, buyQuote;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = _.merge({}, constants_1.constants.DEFAULT_BUY_QUOTE_REQUEST_OPTS, options), feePercentage = _a.feePercentage, shouldForceOrderRefresh = _a.shouldForceOrderRefresh, slippagePercentage = _a.slippagePercentage;
                        assert_1.assert.isString('assetData', assetData);
                        assert_1.assert.isBigNumber('assetBuyAmount', assetBuyAmount);
                        assert_1.assert.isValidPercentage('feePercentage', feePercentage);
                        assert_1.assert.isBoolean('shouldForceOrderRefresh', shouldForceOrderRefresh);
                        assert_1.assert.isNumber('slippagePercentage', slippagePercentage);
                        return [4 /*yield*/, this._getZrxTokenAssetDataOrThrowAsync()];
                    case 1:
                        zrxTokenAssetData = _c.sent();
                        isMakerAssetZrxToken = assetData === zrxTokenAssetData;
                        return [4 /*yield*/, Promise.all([
                                this.getOrdersAndFillableAmountsAsync(assetData, shouldForceOrderRefresh),
                                isMakerAssetZrxToken
                                    ? Promise.resolve(constants_1.constants.EMPTY_ORDERS_AND_FILLABLE_AMOUNTS)
                                    : this.getOrdersAndFillableAmountsAsync(zrxTokenAssetData, shouldForceOrderRefresh),
                                shouldForceOrderRefresh,
                            ])];
                    case 2:
                        _b = __read.apply(void 0, [_c.sent(), 2]), ordersAndFillableAmounts = _b[0], feeOrdersAndFillableAmounts = _b[1];
                        if (ordersAndFillableAmounts.orders.length === 0) {
                            throw new Error(types_1.AssetBuyerError.AssetUnavailable + ": For assetData " + assetData);
                        }
                        buyQuote = buy_quote_calculator_1.buyQuoteCalculator.calculate(ordersAndFillableAmounts, feeOrdersAndFillableAmounts, assetBuyAmount, feePercentage, slippagePercentage, isMakerAssetZrxToken);
                        return [2 /*return*/, buyQuote];
                }
            });
        });
    };
    /**
     * Get a `BuyQuote` containing all information relevant to fulfilling a buy given a desired ERC20 token address.
     * You can then pass the `BuyQuote` to `executeBuyQuoteAsync` to execute the buy.
     * @param   tokenAddress        The ERC20 token address.
     * @param   assetBuyAmount      The amount of asset to buy.
     * @param   options             Options for the request. See type definition for more information.
     *
     * @return  An object that conforms to BuyQuote that satisfies the request. See type definition for more information.
     */
    AssetBuyer.prototype.getBuyQuoteForERC20TokenAddressAsync = function (tokenAddress, assetBuyAmount, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var assetData, buyQuote;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert_1.assert.isETHAddressHex('tokenAddress', tokenAddress);
                        assert_1.assert.isBigNumber('assetBuyAmount', assetBuyAmount);
                        return [4 /*yield*/, this._contractWrappers.devUtils.encodeERC20AssetData(tokenAddress).callAsync()];
                    case 1:
                        assetData = _a.sent();
                        buyQuote = this.getBuyQuoteAsync(assetData, assetBuyAmount, options);
                        return [2 /*return*/, buyQuote];
                }
            });
        });
    };
    /**
     * Returns information about available liquidity for an asset
     * Does not factor in slippage or fees
     * @param   assetData           The assetData of the desired asset to buy (for more info: https://github.com/0xProject/0x-protocol-specification/blob/master/v2/v2-specification.md).
     * @param   options             Options for the request. See type definition for more information.
     *
     * @return  An object that conforms to LiquidityForAssetData that satisfies the request. See type definition for more information.
     */
    AssetBuyer.prototype.getLiquidityForAssetDataAsync = function (assetData, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var shouldForceOrderRefresh, assetPairs, etherTokenAssetData, ordersAndFillableAmounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldForceOrderRefresh = options.shouldForceOrderRefresh !== undefined ? options.shouldForceOrderRefresh : false;
                        assert_1.assert.isString('assetData', assetData);
                        order_utils_1.assetDataUtils.decodeAssetDataOrThrow(assetData);
                        assert_1.assert.isBoolean('options.shouldForceOrderRefresh', shouldForceOrderRefresh);
                        return [4 /*yield*/, this.orderProvider.getAvailableMakerAssetDatasAsync(assetData)];
                    case 1:
                        assetPairs = _a.sent();
                        return [4 /*yield*/, this._getEtherTokenAssetDataOrThrowAsync()];
                    case 2:
                        etherTokenAssetData = _a.sent();
                        if (!assetPairs.includes(etherTokenAssetData)) {
                            return [2 /*return*/, {
                                    tokensAvailableInBaseUnits: new utils_1.BigNumber(0),
                                    ethValueAvailableInWei: new utils_1.BigNumber(0),
                                }];
                        }
                        return [4 /*yield*/, this.getOrdersAndFillableAmountsAsync(assetData, shouldForceOrderRefresh)];
                    case 3:
                        ordersAndFillableAmounts = _a.sent();
                        return [2 /*return*/, calculate_liquidity_1.calculateLiquidity(ordersAndFillableAmounts)];
                }
            });
        });
    };
    /**
     * Given a BuyQuote and desired rate, attempt to execute the buy.
     * @param   buyQuote        An object that conforms to BuyQuote. See type definition for more information.
     * @param   options         Options for the execution of the BuyQuote. See type definition for more information.
     *
     * @return  A promise of the txHash.
     */
    AssetBuyer.prototype.executeBuyQuoteAsync = function (buyQuote, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, ethAmount, takerAddress, feeRecipient, gasLimit, gasPrice, orders, feeOrders, feePercentage, assetBuyAmount, worstCaseQuoteInfo, finalTakerAddress, web3Wrapper, availableAddresses, firstAvailableAddress, formattedFeePercentage, value, txHash, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = _.merge({}, constants_1.constants.DEFAULT_BUY_QUOTE_EXECUTION_OPTS, options), ethAmount = _a.ethAmount, takerAddress = _a.takerAddress, feeRecipient = _a.feeRecipient, gasLimit = _a.gasLimit, gasPrice = _a.gasPrice;
                        assert_1.assert.isValidBuyQuote('buyQuote', buyQuote);
                        if (ethAmount !== undefined) {
                            assert_1.assert.isBigNumber('ethAmount', ethAmount);
                        }
                        if (takerAddress !== undefined) {
                            assert_1.assert.isETHAddressHex('takerAddress', takerAddress);
                        }
                        assert_1.assert.isETHAddressHex('feeRecipient', feeRecipient);
                        if (gasLimit !== undefined) {
                            assert_1.assert.isNumber('gasLimit', gasLimit);
                        }
                        if (gasPrice !== undefined) {
                            assert_1.assert.isBigNumber('gasPrice', gasPrice);
                        }
                        orders = buyQuote.orders, feeOrders = buyQuote.feeOrders, feePercentage = buyQuote.feePercentage, assetBuyAmount = buyQuote.assetBuyAmount, worstCaseQuoteInfo = buyQuote.worstCaseQuoteInfo;
                        if (!(takerAddress !== undefined)) return [3 /*break*/, 1];
                        finalTakerAddress = takerAddress;
                        return [3 /*break*/, 3];
                    case 1:
                        web3Wrapper = new web3_wrapper_1.Web3Wrapper(this.provider);
                        return [4 /*yield*/, web3Wrapper.getAvailableAddressesAsync()];
                    case 2:
                        availableAddresses = _b.sent();
                        firstAvailableAddress = _.head(availableAddresses);
                        if (firstAvailableAddress !== undefined) {
                            finalTakerAddress = firstAvailableAddress;
                        }
                        else {
                            throw new Error(types_1.AssetBuyerError.NoAddressAvailable);
                        }
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        formattedFeePercentage = number_percentage_to_ethertoken_amount_percentage_1.numberPercentageToEtherTokenAmountPercentage(feePercentage || 0);
                        value = ethAmount || worstCaseQuoteInfo.totalEthAmount;
                        return [4 /*yield*/, this._contractWrappers.forwarder
                                .marketBuyOrdersWithEth(orders, assetBuyAmount, orders.map(function (o) { return o.signature; }), formattedFeePercentage, feeRecipient)
                                .sendTransactionAsync({
                                value: value,
                                from: finalTakerAddress.toLowerCase(),
                                gas: gasLimit,
                                gasPrice: gasPrice,
                            })];
                    case 4:
                        txHash = _b.sent();
                        return [2 /*return*/, txHash];
                    case 5:
                        err_1 = _b.sent();
                        if (_.includes(err_1.message, contract_wrappers_1.ContractError.SignatureRequestDenied)) {
                            throw new Error(types_1.AssetBuyerError.SignatureRequestDenied);
                        }
                        else if (_.includes(err_1.message, contract_wrappers_1.ForwarderError.CompleteFillFailed)) {
                            throw new Error(types_1.AssetBuyerError.TransactionValueTooLow);
                        }
                        else {
                            throw err_1;
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the asset data of all assets that are purchaseable with ether token (wETH) in the order provider passed in at init.
     *
     * @return  An array of asset data strings that can be purchased using wETH.
     */
    AssetBuyer.prototype.getAvailableAssetDatasAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var etherTokenAssetData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getEtherTokenAssetDataOrThrowAsync()];
                    case 1:
                        etherTokenAssetData = _a.sent();
                        return [2 /*return*/, this.orderProvider.getAvailableMakerAssetDatasAsync(etherTokenAssetData)];
                }
            });
        });
    };
    /**
     * Grab orders from the map, if there is a miss or it is time to refresh, fetch and process the orders
     * @param assetData                The assetData of the desired asset to buy (for more info: https://github.com/0xProject/0x-protocol-specification/blob/master/v2/v2-specification.md).
     * @param shouldForceOrderRefresh  If set to true, new orders and state will be fetched instead of waiting for the next orderRefreshIntervalMs.
     */
    AssetBuyer.prototype.getOrdersAndFillableAmountsAsync = function (assetData, shouldForceOrderRefresh) {
        return __awaiter(this, void 0, void 0, function () {
            var ordersEntryIfExists, shouldRefresh, result, etherTokenAssetData, zrxTokenAssetData, orderProviderRequest, request, response, isMakerAssetZrxToken, ordersAndFillableAmounts, lastRefreshTime, updatedOrdersEntry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ordersEntryIfExists = this._ordersEntryMap[assetData];
                        shouldRefresh = ordersEntryIfExists === undefined ||
                            shouldForceOrderRefresh ||
                            // tslint:disable:restrict-plus-operands
                            ordersEntryIfExists.lastRefreshTime + this.orderRefreshIntervalMs < Date.now();
                        if (!shouldRefresh) {
                            result = ordersEntryIfExists.ordersAndFillableAmounts;
                            return [2 /*return*/, result];
                        }
                        return [4 /*yield*/, this._getEtherTokenAssetDataOrThrowAsync()];
                    case 1:
                        etherTokenAssetData = _a.sent();
                        return [4 /*yield*/, this._getZrxTokenAssetDataOrThrowAsync()];
                    case 2:
                        zrxTokenAssetData = _a.sent();
                        orderProviderRequest = {
                            makerAssetData: assetData,
                            takerAssetData: etherTokenAssetData,
                            chainId: this.chainId,
                        };
                        request = orderProviderRequest;
                        return [4 /*yield*/, this.orderProvider.getOrdersAsync(request)];
                    case 3:
                        response = _a.sent();
                        // since the order provider is an injected dependency, validate that it respects the API
                        // ie. it should only return maker/taker assetDatas that are specified
                        order_provider_response_processor_1.orderProviderResponseProcessor.throwIfInvalidResponse(response, request);
                        isMakerAssetZrxToken = assetData === zrxTokenAssetData;
                        return [4 /*yield*/, order_provider_response_processor_1.orderProviderResponseProcessor.processAsync(response, isMakerAssetZrxToken, this.expiryBufferSeconds, this._contractWrappers.orderValidator)];
                    case 4:
                        ordersAndFillableAmounts = _a.sent();
                        lastRefreshTime = Date.now();
                        updatedOrdersEntry = {
                            ordersAndFillableAmounts: ordersAndFillableAmounts,
                            lastRefreshTime: lastRefreshTime,
                        };
                        this._ordersEntryMap[assetData] = updatedOrdersEntry;
                        return [2 /*return*/, ordersAndFillableAmounts];
                }
            });
        });
    };
    /**
     * Get the assetData that represents the WETH token.
     * Will throw if WETH does not exist for the current chain.
     */
    AssetBuyer.prototype._getEtherTokenAssetDataOrThrowAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._contractWrappers.devUtils
                        .encodeERC20AssetData(this._contractWrappers.contractAddresses.etherToken)
                        .callAsync()];
            });
        });
    };
    /**
     * Get the assetData that represents the ZRX token.
     * Will throw if ZRX does not exist for the current chain.
     */
    AssetBuyer.prototype._getZrxTokenAssetDataOrThrowAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._contractWrappers.devUtils
                        .encodeERC20AssetData(this._contractWrappers.contractAddresses.zrxToken)
                        .callAsync()];
            });
        });
    };
    return AssetBuyer;
}());
exports.AssetBuyer = AssetBuyer;
//# sourceMappingURL=asset_buyer.js.map